import React from "react";
import Login from "./components/main/Login";
import DoctorLogin from "./components/main/DoctorLogin";
import SyndicateLogin from "./components/main/SyndicateLogin";
import MOFLogin from "./components/main/MOFLogin";
import MOHLogin from "./components/main/MOHLogin";
import DoctorDashboard from "./components/main/Dashboard/DoctorDashboard";
import SyndicateDashboard from "./components/main/Dashboard/SyndicateDashboard";
import MOFDashboard from "./components/main/Dashboard/MOFDashboard";
import MOHDashboard from "./components/main/Dashboard/MOHDashboard";
import PaymentDashboard from "./components/main/payment/PaymentDashboard";
import PendingAndHistoryPayment from "./components/main/payment/PendingAndHistoryPayment";
import ZaincashPayment from "./components/main/payment/ZaincashPayment";

import Context from "./assets/js/context";
import { BrowserRouter, Route, Routes, useLocation } from "react-router-dom";

import VisaMasterPayment from "./components/main/payment/VisaMasterPayment";
import RegisteredDoctors from "./components/main/MOH/RegisteredDoctors";
import MohReportDashboard from "./components/main/MOH/MohReportDashboard";
import AddFatoraForm from "./components/main/payment/AddFatoraForm";



import "./App.css";


import Container from "./components/main/MOF/Container";

const App = () => {
  // const location= useLocation();


  return (
    <div className="App-styles">
      <BrowserRouter>
        <Context.Provider
          value={{
            // value: this.state,
            action: {},
          }}
        >

          <Routes>
            {/* LOGIN ROUTES */}
            <Route exact="true" path="/" element={<Login />} />
            <Route
              exact="true"
              path="/doctor-login"
              element={<DoctorLogin />}
            />
            <Route
              exact="true"
              path="/syndicate-login"
              element={<SyndicateLogin />}
            />
            <Route exact="true" path="/mof-login" element={<MOFLogin />} />
            <Route exact="true" path="/moh-login" element={<MOHLogin />} />

            {/* DASHBOARD ROUTES */}
            <Route
              exact="true"
              path="/doctor-dashboard"
              element={<DoctorDashboard />}
            />
            <Route
              exact="true"
              path="/syndicate-dashboard"
              element={<SyndicateDashboard />}
            />
            <Route
              exact="true"
              path="/mof-dashboard"
              element={<MOFDashboard />}
            />
            <Route
              exact="true"
              path="/moh-dashboard"
              element={<MOHDashboard />}
            />

            {/* SECURE PAYMENT */}
            <Route
              exact="true"
              path="/secure-payment"
              element={<PaymentDashboard />}
            />
            <Route
              exact="true"
              path="/zaincash-payment"
              element={<ZaincashPayment />}
            />
            <Route
              exact="true"
              path="/pending-and-history-payment"
              element={<PendingAndHistoryPayment />}
            />
            <Route
              exact="true"
              path="/add_fatora"
              element={<AddFatoraForm />}
            />
            <Route
              exact="true"
              path="/visa-master-payment"
              element={<VisaMasterPayment />}
            />

            {/* MOH */}
            <Route
              exact="true"
              path="/registered-doctors"
              element={<RegisteredDoctors />}
            />
            <Route
              exact="true"
              path="/report-dashboard-moh"
              element={<MohReportDashboard />}
            />

            {/* MOF */}
            <Route
              exact="true"
              path="/registered-doctors-mof"
              element={<Container />}
            />
            <Route
              exact="true"
              path="/report-dashboard-mof"
              element={<Container />}
            />
            <Route
              exact="true"
              path="/addGroups-dashboard-moh"
              element={<Container />}
            />
            <Route
              exact="true"
              path="/GroupsOfCarriers"
              element={<Container />}
            />
            <Route
              exact="true"
              path="/AddVarieties"
              element={<Container />}
            />
            <Route
              exact="true"
              path="/AddActivityType"
              element={<Container />}
            />
            <Route
              exact="true"
              path="/income_tax_report"
              element={<Container />}
            />

            <Route
              exact="true"
              path="/insert_income_tax_report"
              element={<Container />}
            />

            <Route
              exact="true"
              path="/income_estimate_form"
              element={<Container />}
            />

            <Route
              path="/other_business"
              element={<Container />}
            />

            <Route
              path="/income_estimate_class"
              element={<Container />}
            />

            <Route
              exact="true"
              path="/add_branch"
              element={<Container />}
            />
            <Route
              exact="true"
              path="/add_role"
              element={<Container />}
            />
            <Route
              exact="true"
              path="/add_permission"
              element={<Container />}
            />
            <Route
              exact="true"
              path="/add_stage"
              element={<Container />}
            />
            <Route
              exact="true"
              path="/add_transaction_type"
              element={<Container />}
            />
            <Route
              exact="true"
              path="/add_approval_status"
              element={<Container />}
            />
            <Route
              exact="true"
              path="/add_user"
              element={<Container />}
            />

            <Route
              exact="true"
              path="/AddSections"
              element={<Container />}
            />


            <Route
              exact="true"
              path="/stage_transaction_type"
              element={<Container />}
            />

          </Routes>

        </Context.Provider>
      </BrowserRouter>
    </div>
  );
}


export default App;
